var version = {
    "name":      "dativery",
    "buildDateCode": "20260429-070940",
    "buildDate": "Wed Apr 29 2026 07:09:40 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260429-070940",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;